function typeahead(typeaheadContainerElement) {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    var currentFocus;

    var inputElement = $(typeaheadContainerElement).find('input')[0];

    var categoryDictionary = JSON.parse($(typeaheadContainerElement).attr('data-typeahead-dictionary'));

    var typeaheadGroupLimit = $(typeaheadContainerElement).attr('data-typeahead-grouplimit')

    /*execute a function when someone writes in the text field:*/
    $(inputElement).on('input focus', throttle(function () {

        if (!$(this).val() || $(this).val().length <= 1) {
            closeAllLists();
            return false;
        }

        currentFocus = -1;

        /*create a DIV element that will contain the items (values):*/

        var listContainerElement = document.querySelector('#' + "typeahead-list-" + this.id);

        if (!listContainerElement) {
            listContainerElement = document.createElement("DIV");
            listContainerElement.setAttribute("id", "typeahead-list-" + this.id);
            listContainerElement.setAttribute("class", "typeahead-list");
            /*append the DIV element as a child of the autocomplete container:*/
            this.parentNode.appendChild(listContainerElement);
        }

        var kyruusData;

        //$(typeaheadContainerElement).find('loading-container').show();

        $.ajax({
            type: "GET",
            url: '/api/sitecore/Kyruus/GetTypeaheadAJAX',
            data: {
                "search_phrase": inputElement.value,
                "categories": Object.keys(categoryDictionary).join(',')
            },
            //dataType: 'application/json',
            success: function (data) {
                kyruusData = data;
                clearErrors();

                if (data === null || data.length === 0) {
                    $(listContainerElement).hide();
                    //reportError();
                }
                else {
                    generateList();
                    $(listContainerElement).show();
                }                
            },
            error: function (jqXHR, textStatus, errorThrown) {
                clearErrors();
                //reportError(errorThrown);
            },
            complete: function (jqXHR, textStatus) {
                //$(typeaheadContainerElement).find('loading-container').hide();
            }
        });

        function clearErrors() {
            var elem = listContainerElement.querySelector('.error');
            if (elem)
                listContainerElement.removeChild(elem);
        }

        function reportError(errorThrown) {
            var errorElement = document.createElement("p");
            errorElement.setAttribute("class", "error");
            errorElement.innerHTML = "There was an issue with typeahead.";
            listContainerElement.appendChild(errorElement);
        }

        function generateList() {
            var listElement = document.createElement("ul");
            listElement.setAttribute("class", "");

            //for each category item
            $.each(kyruusData, function (catKey, catValue) {

                if (!catValue) {
                    return true;
                }

                var listItemElement = document.createElement("li");
                listItemElement.setAttribute("class", "typeahead-list-category typeahead-list-item");
                var listItemElementHeading = document.createElement("div");
                listItemElementHeading.setAttribute("class", "typeahead-list-category-heading");
                listItemElementHeading.setAttribute("data-typeahead-category", catKey);

                if (categoryDictionary[catKey]) {
                    listItemElementHeading.innerHTML = categoryDictionary[catKey];
                }
                else {
                    listItemElementHeading.innerHTML = catKey;
                }

                listItemElement.appendChild(listItemElementHeading);

                var innerListElement = document.createElement("ul");
                innerListElement.setAttribute("class", "typeahead-sublist");

                //for each data match
                $.each(catValue, function (index, value) {

                    var innerListItemElement = document.createElement("li");
                    innerListItemElement.setAttribute("class", "typeahead-list-item");

                    //if its a provider or marketable location, direct link them
                    if (catKey == "provider_name" || catKey == "marketable_locations") {
                        var innerListItemAnchorElement = document.createElement("a");
                        var urlFormat = $(typeaheadContainerElement).attr('data-typeahead-kyruus-url-format');

                        if (catKey == "provider_name") {
                            var providerUrlNameSplit = value.name.split(" ");
                            if (providerUrlNameSplit.length > 2) {
                                value.name = String.format("{0} {1}", providerUrlNameSplit.shift(), providerUrlNameSplit.pop());
                            }

                            //replace (all) spaces with hyphens
                            value.name = value.name.replaceAll(' ', '-');

                            //replace all non valid URL characters with empty string
                            value.name = value.name.replace(/[^a-zA-Z0-9-_]/g, '');

                            innerListItemAnchorElement.setAttribute("href", String.format(urlFormat, value.name, value.id).toLowerCase());
                            innerListItemAnchorElement.innerHTML = value.highlight;
                        }
                        //marketable locations don't give us "name" for whatever reason, so we use the highlight's textcontent
                        else {
                            //rely on the browser to strip out the text by creating a fake element
                            var tempNode = document.createElement("div");
                            tempNode.innerHTML = value.highlight;

                            //replace (all) spaces with hyphens
                            var name = tempNode.textContent.trim().replaceAll(' ', '-');

                            //replace all non valid URL characters with empty string
                            name = name.replace(/[^a-zA-Z0-9-_]/g, '');

                            innerListItemAnchorElement.setAttribute("href", String.format(urlFormat, name, value.id).toLowerCase());
                            innerListItemAnchorElement.innerHTML = value.highlight;
                        }
            
                        innerListItemElement.appendChild(innerListItemAnchorElement);
                    }
                    else {
                        var innerListItemSpanElement = document.createElement("span");
                        innerListItemSpanElement.setAttribute("class", "typeahead-link");
                        innerListItemSpanElement.setAttribute("data-typeahead-name", value.name);
                        innerListItemSpanElement.setAttribute("data-typeahead-type", value.type);
                        if (value.highlight) {
                            innerListItemSpanElement.innerHTML = value.highlight;
                        }
                        else {
                            innerListItemSpanElement.innerHTML = value.name;
                        }
                        innerListItemElement.appendChild(innerListItemSpanElement);

                        if (catKey == "location_name") {
                            innerListItemElement.addEventListener("click", function (e) {
                                $(inputElement).val(value.name);
                                $('input[name=unified]').val('');
                                $('input[name=location_name]').val(value.name);
                                $(this).closest('form').submit();
                                //close the list
                                closeAllLists();
                            });
                        }
                        else if (value.type == "specialty") {
                            innerListItemElement.addEventListener("click", function (e) {
                                //activate the associated specialty
                                $(inputElement).val(value.name);
                                $('input[name=unified]').val('');
                                $('input[name=specialty]').val(value.name);
                                $(this).closest('form').submit();
                                //close the list
                                closeAllLists();
                            });
                        }
                        else {
                            innerListItemElement.innerHTML += "<input type='hidden' value='" + value.name + "'>";

                            innerListItemElement.addEventListener("click", function (e) {
                                //insert the value into the text field
                                $(inputElement).val(value.name);
                                $(this).closest('form').submit();
                                //close the list
                                closeAllLists();
                            });
                        }     
                    }

                    if (typeaheadGroupLimit && index >= typeaheadGroupLimit) {
                        $(innerListItemElement).hide();
                        $(innerListItemElement).addClass("show-more");
                    }

                    innerListElement.appendChild(innerListItemElement);
                });

                if (catValue.length > typeaheadGroupLimit) {
                    var showMoreListItem = document.createElement("li");
                    showMoreListItem.setAttribute("class", "typeahead-list-item");
                    var showMoreLink = document.createElement("a");
                    showMoreLink.setAttribute("data-show-more-trigger", "");
                    $(showMoreLink).addClass("show-more-link");
                    showMoreLink.innerHTML = "Show More (" + (catValue.length - 3) + ")";
                    showMoreListItem.appendChild(showMoreLink);
                    innerListElement.appendChild(showMoreListItem);

                    $(showMoreLink).on('click', function () {
                        var parent = $(this).parent().parent();

                        //hide showmorelabel via parent
                        $(showMoreLink).parent().hide();
                        //show hidden items
                        $(parent).find('.show-more').show();
                        //show showless label
                        $(parent).find('[data-show-less-trigger]').parent().show();
                    });

                    var showLessListItem = document.createElement("li");
                    showLessListItem.setAttribute("class", "typeahead-list-item");
                    var showLessLink = document.createElement("a");
                    showLessLink.setAttribute("data-show-less-trigger", "");
                    $(showLessLink).addClass("show-more-link");
                    showLessLink.innerHTML = "Show Less";
                    showLessListItem.appendChild(showLessLink);
                    $(showLessListItem).hide();
                    innerListElement.appendChild(showLessListItem);

                    $(showLessLink).on('click', function () {
                        var parent = $(this).parent().parent();

                        //hide showlesslabel via parent
                        $(showLessLink).parent().hide();
                        //show hidden items
                        $(parent).find('.show-more').hide();
                        //show showmore label
                        $(parent).find('[data-show-more-trigger]').parent().show();
                    });
                }

                listItemElement.appendChild(innerListElement);
                listElement.appendChild(listItemElement);
            });

            listContainerElement.innerHTML = '';
            listContainerElement.appendChild(listElement);
        }
    }, 1000));

    /*execute a function presses a key on the keyboard:*/
    $(inputElement).on('keydown', function (e) {
        //var x = document.getElementById("typeahead-list-" + this.id);
        //if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 13) {
            //If the ENTER key is pressed
            closeAllLists();
            $(this).closest('form').submit();
            $(this).blur();
        }
        //else if (e.keyCode == 40)
        //{
        //    /*If the arrow DOWN key is pressed,
        //    increase the currentFocus variable:*/
        //    currentFocus++;
        //    /*and and make the current item more visible:*/
        //    addActive(x);
        //}
        //else if (e.keyCode == 38)
        //{
        //    //If the arrow UP key is pressed, decrease the currentFocus variable:
        //    currentFocus--;
        //    //and and make the current item more visible:
        //    addActive(x);
        //}
    });

    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }

    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    window.closeAllLists = function(elementToIgnore) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("typeahead-list");
        for (var i = 0; i < x.length; i++) {
            if (elementToIgnore != x[i] && elementToIgnore != inputElement) {
                //x[i].parentNode.removeChild(x[i]);
                $(x).hide();
            }
        }
    }

    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {

        if (e.target.hasAttribute('data-show-more-trigger') || e.target.hasAttribute('data-show-less-trigger')) {
            return;
        }

        closeAllLists(e.target);
    });
}

/*initiate the typeahead function on matching elements */
$(document).ready(function () {
    $('[data-typeahead-wrapper]').each(function () {
        typeahead($(this));
    });
});

//var sampleData = {
//    "conditions_symptoms": [
//        {
//            "highlight": "cough and <em>col</em>d symptoms",
//            "name": "cough and cold symptoms",
//            "type": "term",
//            "uuid": "T00030581"
//        },
//        {
//            "highlight": "<em>col</em>itis",
//            "name": "colitis",
//            "type": "concept",
//            "uuid": "C3656722"
//        },
//        {
//            "highlight": "<em>col</em>larbone fx",
//            "name": "collarbone fx",
//            "type": "term",
//            "uuid": "T00049004"
//        },
//        {
//            "highlight": "<em>col</em>onic squamous cell carcinoma",
//            "name": "colonic squamous cell carcinoma",
//            "type": "concept",
//            "uuid": "C3667446"
//        },
//        {
//            "highlight": "<em>col</em>lagenous <em>col</em>itis",
//            "name": "collagenous colitis",
//            "type": "concept",
//            "uuid": "C3663474"
//        }
//    ],
//    "location_name": [
//        {
//            "highlight": "Doylestown Health <em>Col</em>orectal Specialists",
//            "name": "Doylestown Health Colorectal Specialists"
//        },
//        {
//            "highlight": "Center for <em>Col</em>on & Rectal Health, Inc.",
//            "name": "Center for Colon & Rectal Health, Inc."
//        }
//    ],
//    "network_affiliation": [
//        {
//            "highlight": "Hahnemann University Hospital/Drexel University <em>Col</em>lege Of Medicine",
//            "name": "Hahnemann University Hospital/Drexel University College Of Medicine"
//        },
//        {
//            "highlight": "New York Presbyterian / <em>Col</em>umbia University Medical Center",
//            "name": "New York Presbyterian / Columbia University Medical Center"
//        },
//        {
//            "highlight": "University Of Florida <em>Col</em>lege Of Medicine Jacksonville",
//            "name": "University Of Florida College Of Medicine Jacksonville"
//        }
//    ],
//    "specialties": [
//        {
//            "highlight": "<em>Col</em>on and Rectal Surgery",
//            "name": "Colon and Rectal Surgery",
//            "type": "specialty",
//            "uuid": "E0000023"
//        },
//        {
//            "highlight": "Comprehensive Ophthalmology",
//            "name": "Comprehensive Ophthalmology",
//            "type": "specialty",
//            "uuid": "E0000104"
//        },
//        {
//            "highlight": "Clinical and Laboratory Pathology",
//            "name": "Clinical and Laboratory Pathology",
//            "type": "specialty",
//            "uuid": "E0000136"
//        },
//        {
//            "highlight": "Clinical Psychology",
//            "name": "Clinical Psychology",
//            "type": "specialty",
//            "uuid": "E0000386"
//        },
//        {
//            "highlight": "Clinical Informatics",
//            "name": "Clinical Informatics",
//            "type": "specialty",
//            "uuid": "E0000430"
//        }
//    ],
//    "treatments_procedures": [
//        {
//            "highlight": "<em>col</em>onoscopy",
//            "name": "colonoscopy",
//            "type": "concept",
//            "uuid": "C3656730"
//        },
//        {
//            "highlight": "<em>col</em>poscopy",
//            "name": "colposcopy",
//            "type": "concept",
//            "uuid": "C3656739"
//        },
//        {
//            "highlight": "<em>col</em>ostomy",
//            "name": "colostomy",
//            "type": "concept",
//            "uuid": "C3656734"
//        },
//        {
//            "highlight": "<em>col</em>ectomy",
//            "name": "colectomy",
//            "type": "concept",
//            "uuid": "C3656720"
//        },
//        {
//            "highlight": "<em>col</em>popexy",
//            "name": "colpopexy",
//            "type": "concept",
//            "uuid": "C3656737"
//        }
//    ]
//};

/* jquery ui autcomplete */
//$(function () {
//    $.widget("custom.catcomplete", $.ui.autocomplete, {
//        _create: function () {
//            this._super();
//            this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
//        },
//        _renderMenu: function (ul, items) {
//            var that = this,
//                currentCategory = "";
//            $.each(items, function (index, item) {
//                var li;
//                if (item.category != currentCategory) {
//                    ul.append("<li class='ui-autocomplete-category'>" + item.category + "</li>");
//                    currentCategory = item.category;
//                }
//                li = that._renderItemData(ul, item);
//                if (item.category) {
//                    li.attr("aria-label", item.category + " : " + item.label);
//                }
//            });
//        }
//    });
//    var data = [
//        { label: "anders", category: "" },
//        { label: "andreas", category: "" },
//        { label: "antal", category: "" },
//        { label: "annhhx10", category: "Products" },
//        { label: "annk K12", category: "Products" },
//        { label: "annttop C13", category: "Products" },
//        { label: "anders andersson", category: "People" },
//        { label: "andreas andersson", category: "People" },
//        { label: "andreas johnson", category: "People" }
//    ];

//    $("[data-autoc]").catcomplete({
//        delay: 0,
//        source: data
//    });
//});